import { type } from 'arktype';

const utcInstantPattern = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d{1,3})?Z(?![\s\S])/;

export const utcInstantSchema = type(utcInstantPattern).narrow((instant, ctx) => {
  const parsed = new Date(instant);
  const [, year, month, day] = utcInstantPattern.exec(instant) ?? [];

  return (
    (!Number.isNaN(parsed.getTime()) &&
      parsed.getUTCFullYear() === Number(year) &&
      parsed.getUTCMonth() === Number(month) - 1 &&
      parsed.getUTCDate() === Number(day)) ||
    ctx.mustBe('a valid ISO-8601 UTC instant ending in Z')
  );
});
